<template>
	<!-- Suggerimento breve apribile al passaggio del mouse e al click/tap. v-tooltip e v-menu open-on-hover non
		si aprono in modo affidabile al tocco (Vuetify 2 ascolta solo mouseenter/mouseleave): qui il passaggio del
		mouse apre e chiude, il click o il tap fissano il suggerimento finché non si clicca fuori o di nuovo -->
	<v-menu
		:value="hover || pinned"
		:open-on-click="false"
		:close-on-content-click="false"
		:max-width="maxWidth"
		:disabled="disabled"
		offset-y
		@input="onInput"
	>
		<template v-slot:activator="{ attrs }">
			<slot name="activator" :on="listeners" :attrs="attrs">
				<v-btn
					icon
					:small="small"
					:x-small="!small"
					class="help-hint__button"
					:aria-label="label"
					v-bind="attrs"
					v-on="listeners"
				>
					<v-icon :small="small" :x-small="!small">mdi-help-circle-outline</v-icon>
				</v-btn>
			</slot>
		</template>
		<v-card class="pa-3 body-2" @pointerenter="cancelClose" @pointerleave="scheduleClose">
			<slot :close="close">{{ text }}</slot>
		</v-card>
	</v-menu>
</template>

<script>
export default {
	name: 'HelpHint',
	props: {
		// testo del suggerimento (lo slot di default lo sostituisce per contenuti con link o formattazione)
		text: {
			type: String,
			default: ''
		},
		maxWidth: {
			type: [Number, String],
			default: 300
		},
		// icona "?" small (titoli delle card) o x-small (dentro le tabelle)
		small: {
			type: Boolean,
			default: false
		},
		label: {
			type: String,
			default: 'Aiuto'
		},
		disabled: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			hover: false,
			pinned: false,
			closeTimeout: null
		}
	},
	computed: {
		// Listener per l'attivatore (anche quelli personalizzati dello slot activator)
		listeners() {
			return {
				pointerenter: this.onPointerEnter,
				pointerleave: this.onPointerLeave,
				click: this.onClick
			}
		}
	},
	beforeDestroy() {
		clearTimeout(this.closeTimeout)
	},
	methods: {
		// Solo il mouse apre al passaggio: al tocco il browser simula l'ingresso e il click lo richiuderebbe subito
		onPointerEnter(event) {
			if (this.disabled || event.pointerType !== 'mouse') return
			this.cancelClose()
			this.hover = true
		},
		onPointerLeave(event) {
			if (event.pointerType !== 'mouse') return
			this.scheduleClose()
		},
		// Il click (o il tap) fissa il suggerimento aperto; un secondo click lo chiude
		onClick(event) {
			if (this.disabled) return
			event.stopPropagation()
			this.pinned = !this.pinned
			if (!this.pinned) this.hover = false
		},
		// Ritardo breve: il mouse può passare dall'attivatore al suggerimento senza chiuderlo
		scheduleClose() {
			clearTimeout(this.closeTimeout)
			this.closeTimeout = setTimeout(() => {
				this.hover = false
			}, 150)
		},
		cancelClose() {
			clearTimeout(this.closeTimeout)
		},
		// Per i link dentro il suggerimento (es. apertura di un dialog)
		close() {
			this.hover = false
			this.pinned = false
		},
		// Click fuori dal suggerimento: v-menu chiude
		onInput(value) {
			if (!value) {
				this.hover = false
				this.pinned = false
			}
		}
	}
}
</script>

<style scoped>
.help-hint__button {
	vertical-align: middle;
}
</style>
